module.exports = __webpack_public_path__ + "argegation.0600639f67115ae1074b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/argegation.png
// module id = ./src/assets/img/argegation.png
// module chunks = main